import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [backendMessage, setBackendMessage] = useState('');

  useEffect(() => {
    fetch('/api/hello')
      .then((res) => res.json())
      .then((data) => setBackendMessage(data.message))
      .catch(() => setBackendMessage('Backend not connected'));
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Hello World!</h1>
        <p>React + Node.js is up and running.</p>
        <p style={{ fontSize: '0.9rem', opacity: 0.7 }}>
          Backend says: {backendMessage || 'Loading...'}
        </p>
      </header>
    </div>
  );
}

export default App;
